import { browserPageActions } from './slices/browserPage';
import { chatActions } from './slices/chat';
import { comparisonNotificationActions } from './slices/comparisonNotification';
import { complaintsActions } from './slices/complaints';
import { jsonQueryActions } from './slices/jsonQuery';
import { listingLayoutActions } from './slices/listingLayout';
import { mapConfigurationActions } from './slices/mapConfiguration';
import { mapControlsActions } from './slices/mapControls';

export const reduxActions = {
  browserPage: browserPageActions,
  chat: chatActions,
  jsonQuery: jsonQueryActions,
  listingLayout: listingLayoutActions,
  mapConfiguration: mapConfigurationActions,
  mapControls: mapControlsActions,
  complaints: complaintsActions,
  comparisonNotification: comparisonNotificationActions,
};
